<script>
    import BaseButton from "@main/packages/BaseButton";
    import BasePrice from "@main/packages/BasePrice";
    import HeaderCartProduct from "@/components/header/HeaderCartProduct";

    export default {
        name: "HeaderCartDropdown",
        components: {
            BaseButton,
            BasePrice,
            HeaderCartProduct,
        },
        props: {
            cart: Object,
            variant: String,
            size: String,
        },
        methods: {
            onRemoveProduct(productId) {
                this.$emit("on-remove-product", productId);
            },
        },
    };
</script>

<template>
    <div class="header-cart-dropdown">
        <div class="header-cart-dropdown__body">
            <div
                v-for="product in cart.productsList"
                :key="product.id"
                class="header-cart-dropdown__product"
            >
                <header-cart-product
                    :product="product"
                    @remove-product="onRemoveProduct"
                ></header-cart-product>
            </div>
        </div>

        <div class="header-cart-dropdown__total">
            <div class="header-cart-dropdown__text">Товаров на сумму:</div>
            <div class="header-cart-dropdown__number">
                <base-price :price="cart.totalPrice"></base-price>
            </div>
        </div>

        <div class="header-cart-dropdown__controls">
            <base-button
                class="header-cart-dropdown__button"
                :variant="variant"
                :size="size"
                @click="$router.push({ name: 'Order' })"
            >
                Оформить заказ
            </base-button>
        </div>
    </div>
</template>

<style lang="scss">
    .header-cart-dropdown {
        background-color: #fff;
        border: var(--cart-dropdown-border);
        border-radius: var(--cart-dropdown-radius);
        box-shadow: var(--cart-dropdown-shadow);
        overflow: hidden;
    }

    .header-cart-dropdown__body {
        max-height: 316px;
        padding-top: 4px;
        overflow: auto;
        scrollbar-width: thin;
        &::-webkit-scrollbar {
            width: 6px;
        }
    }

    .header-cart-dropdown__product {
        position: relative;
        &::before,
        &::after {
            content: "";
            position: absolute;
            z-index: 1;
            top: 0;
            height: 100%;
            width: var(--cart-dropdown-offset);
            background-color: #fff;
        }
        &::before {
            left: 0;
        }
        &::after {
            right: 0;
        }
    }

    .header-cart-dropdown__total {
        display: flex;
        justify-content: space-between;
        margin: 0 var(--cart-dropdown-offset) 16px;
        padding: 16px calc(16px - var(--cart-dropdown-offset));
        border-bottom: 1px solid var(--cart-border-color);
    }

    .header-cart-dropdown__text {
        color: var(--primary-text);
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
    }

    .header-cart-dropdown__number {
        color: var(--primary-text);
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
    }

    .header-cart-dropdown__controls {
        padding: 0 16px 16px;
    }

    .header-cart-dropdown__button {
        width: 100%;
    }
</style>
